import React from 'react'


export const EventTab = () => {
  return (
    <div className="no-found-box">
      <div className="no-found">No events yet</div>
    </div>
  );
}